import { useState } from 'react';
import AttrSuggest from './AttrSuggest';

function AttrBox() {
	const [state, setState] = useState({
		text: '',
	});

	const handleOnChange = (e: any) => {
		setState({ ...state, text: e });
	};

	return (
		<div>
      <h3 className="mb-4 mt-4">Ingrese el texto a buscar su abreviatura</h3>
      <p className="text-muted">El sistema desplegará una sugerencia para nombrar el atributo basado en las palabras ingresadas </p>
			<AttrSuggest value={state.text} onChange={handleOnChange} />
      <div className="d-block mb-4"></div>
		</div>
	);
}

export { AttrBox };
